import { carouselData } from '@/mocks/home';

export default function CarouselSection() {
  return (
    <section id="carousel" className="w-full py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            重磅专题追踪
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-2xl mx-auto">
            深度调查报道，聚焦娱乐圈最受关注的黑料爆料事件。每一篇都是团队的调查心血。
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {carouselData.map((item) => (
            <article
              key={item.id}
              className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden hover:border-primary-200 transition-all duration-300 flex flex-col cursor-pointer"
            >
              <div className="relative overflow-hidden h-44 sm:h-48">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="inline-block bg-primary-500 text-white px-2.5 py-1 rounded-full text-xs font-semibold whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>

              <div className="p-4 md:p-5 flex flex-col flex-1">
                <h3 className="font-heading text-sm md:text-base font-bold text-foreground-950 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-foreground-500 text-xs leading-relaxed line-clamp-3 mb-4 flex-1">
                  {item.excerpt}
                </p>
                <div className="flex items-center justify-between text-xs text-foreground-400">
                  <span>{item.date}</span>
                  <span className="flex items-center gap-1 text-primary-500 group-hover:gap-2 transition-all whitespace-nowrap">
                    阅读全文
                    <i className="ri-arrow-right-line text-[10px]"></i>
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}